import React from "react";

const TopBanner = ({ name }) => {
  return (
    <>
      <section id="all-banner" className="Services">
        <h1>{name}</h1>
      </section>
    </>
  );
};

export default TopBanner;
